import { Component } from '@angular/core';

@Component({
  templateUrl: './payment-details-page.component.html'
})
export class PaymentDetailsPageComponent {}
